import React, {useEffect, useState} from 'react'
import {
  getConfigurationByName,
  updateConfigurationByConfigID,
} from '../../../../../../API/api-endpoint'
import ToastUtils, {ErrorToastUtils} from '../../../../../../utils/ToastUtils'

const PayUFunYdPaymentPlugin = () => {
  const [configID, setConfigId] = useState(0)
  const [payufunydPaymentConfig, setpayufunydPaymentConfig] = useState<any>({
    isEnabled: true,
    isEnabledIos: true,
    merchant_key: '',
    merchant_salt: '',
    isTestMode: false,
    taxPercentage: 18,
  })

  useEffect(() => {
    getConfiguration()
  }, [])

  const handleChange = (event: any) => {
    let name = event.target.name
    let value = event.target.checked

    if (name === 'isEnabled' || name === 'isEnabledIos' || name === 'isTestMode') {
      setpayufunydPaymentConfig({...payufunydPaymentConfig, [name]: value})
      updateConfiguration({...payufunydPaymentConfig, [name]: value})
    } else if (name === 'taxPercentage') {
      let rawVal = event.target.value
      if (rawVal === '') {
        setpayufunydPaymentConfig({...payufunydPaymentConfig, [name]: ''})
        return
      }
      let val = parseFloat(rawVal)
      if (isNaN(val)) return
      if (val < 0) val = 0
      if (val > 100) val = 100
      setpayufunydPaymentConfig({...payufunydPaymentConfig, [name]: val})
    } else {
      setpayufunydPaymentConfig({...payufunydPaymentConfig, [name]: event.target.value})
    }
  }

  const onBlurUpdate = () => {
    let finalConfig = {...payufunydPaymentConfig}
    if (finalConfig.taxPercentage === '' || isNaN(parseFloat(finalConfig.taxPercentage))) {
      finalConfig.taxPercentage = 18
      setpayufunydPaymentConfig(finalConfig)
    }
    updateConfiguration(finalConfig)
  }

  const getConfiguration = async () => {
    let result = await getConfigurationByName('payufunyd')
    if (result.success) {
      let parsedData = JSON.parse(result.data.values)
      setConfigId(result.data.id)
      setpayufunydPaymentConfig({
        isEnabled: parsedData?.isEnabled ?? false,
        isEnabledIos: parsedData?.isEnabledIos ?? true,
        merchant_key: parsedData?.merchant_key ?? '',
        merchant_salt: parsedData?.merchant_salt ?? '',
        isTestMode: parsedData?.isTestMode ?? false,
        taxPercentage: parsedData?.taxPercentage ?? 18,
      })
    }
  }

  const updateConfiguration = async (config: any) => {
    let result = await updateConfigurationByConfigID(configID, config, null)
    if (result.success) {
      getConfiguration()
      ToastUtils({type: 'success', message: 'Configuration Saved SuccessFully'})
    } else {
      ErrorToastUtils()
    }
  }

  return (
    <div className='card'>
      <div className='card-title p-8'>
        <h2>PayU Fun YD Payment settings</h2>
      </div>
      <div className='card-body'>
        <div className='row no-gutters'>
          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Enable PayU Fun YD plugin</strong>
            </p>
            <p className='text-muted'>Enable or disable PayU Fun YD plugin</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='payufunydisEnabled'
                name='isEnabled'
                checked={payufunydPaymentConfig.isEnabled}
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Enable PayU Fun YD plugin for iOS</strong>
            </p>
            <p className='text-muted'>Enable or disable PayU Fun YD plugin for iOS</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='payufunydisEnabledIos'
                name='isEnabledIos'
                checked={payufunydPaymentConfig.isEnabledIos}
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Merchant Key</strong>
            </p>
            <p className='text-muted'>-</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex w-100'>
              <input
                type='text'
                className='form-control'
                name='merchant_key'
                value={payufunydPaymentConfig.merchant_key}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Merchant Salt</strong>
            </p>
            <p className='text-muted'>-</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex w-100'>
              <input
                type='text'
                className='form-control'
                name='merchant_salt'
                value={payufunydPaymentConfig.merchant_salt}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Enable Test Mode</strong>
            </p>
            <p className='text-muted'>Toggle sandbox / live mode. When enabled, payments hit test environment.</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='payufunydTestMode'
                name='isTestMode'
                checked={payufunydPaymentConfig.isTestMode}
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Tax Percentage (%)</strong>
            </p>
            <p className='text-muted'>Dynamic percentage between 0 and 100</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex w-100'>
              <input
                type='number'
                min='0'
                max='100'
                step='any'
                className='form-control'
                name='taxPercentage'
                placeholder='e.g. 18'
                value={payufunydPaymentConfig.taxPercentage}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PayUFunYdPaymentPlugin
